<div class="relative new-request-wrapper py-1 pl-1" role="dialog" data-test-id="dialog_new_request" cdkTrapFocus>
  <button mat-dialog-close
        type="button"
        class="reset-button absolute t-0 r-0 icon icon-close close"
        data-test-id="button_close_dialog" cdkFocusInitial></button>
  <h3 mat-dialog-title
      class="medium color-black">{{'module.requests.text.create-new' | translate}}</h3>
  <mat-dialog-content>
    <h5 class="h6 m-0 mb-1 medium">{{'module.requests.text.production' | translate}}:</h5>
    <div class="row no-wrap">
      <div *ngFor="let request of items; first as isFirst; last as isLast"
           class="d-flex ai-center jc-center {{'order-'+request.displayOrder}}"
           [ngClass]="{'d-none': request.category !== 'production' || request.type === 'PRODUCTION_REQUEST'}">
        <div class="new-item p-1 d-flex column jc-around mr-1"
             role="button" tabindex=0
             [ngClass]="{'disabled': isItemDisabled(request.type)}"
             (click)="selectRequestType(request)">
          <span class="icon icon-{{request.icon}}"></span>
          <span class="fs-md medium">{{request.name}}</span>
          <span class="info uppercase fs-xs">
              <span>{{request.taskCount}} {{'module.requests.text.stages' | translate}}, - </span>
              <span>{{request.expectedDurationWeeks}} {{'module.requests.text.weeks' | translate}}</span>
            </span>
        </div>
      </div>
    </div>
    <h5 class="h6 my-1 mt-3 medium">{{'module.requests.text.design' | translate}}:</h5>
    <div class="row no-wrap mb-2">
      <div *ngFor="let item of items; first as isFirst; last as isLast"
           class="d-flex ai-center jc-center {{'order-'+item.displayOrder}}"
           [ngClass]="{'d-none': item.category !== 'design' || (item.type === 'DIGITAL_ASSETS_REQUEST' && env.hideSomeUIElements)} ">
        <div>
          <div class="new-item p-1 d-flex column jc-around mr-1"
               [ngClass]="{'disabled': isItemDisabled(item.type)}"
               role="button" tabindex=0
               (click)="selectRequestType(item)">
            <span class="icon icon-{{item.icon}}"></span>
            <span class="fs-md medium">{{item.name}}</span>
            <span class="info uppercase fs-xs">
              <span [attr.data-test-id]="['task_count', 'request', item.type?.toLowerCase()].join('_')">{{item.taskCount}} {{'module.requests.text.stages' | translate}}, - </span>
              <span [attr.data-test-id]="['expected_duration_weeks', 'request', item.type?.toLowerCase()].join('_')">{{item.expectedDurationWeeks}} {{'module.requests.text.weeks' | translate}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
